import { InventoryFormikValuesDto } from "../InventoryFormikValuesDto";

export const createEmptyInventoryFormik = (): InventoryFormikValuesDto => {
  const formik: InventoryFormikValuesDto = {
    singleCuUnits: '',
    singleDpUnits: '',
    fullDuUnits: '',
    accountedPrice: '',
    accountedValue: '',
    expirationDate: '',
    productionDate: '',
    manufacturerId: '',
    movementType: '',
    status: '',
    condition: '',
    lot: '',
    chamberNumber: '',
    column: '',
    letter: '',
    level: '',
    supplierId: '',
    sellOrderId: '',
    purchaseOrderId: '',
    isInvoiced: false,
    isRemoved: false,
    notes: '',
    transactionDateTime: '',
    warehouseOwnerId: '',
    warehouseId: '',
  };
  return formik;
};